/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Money = {
    amount: number;
    currency: Money.currency;
};
export namespace Money {
    export enum currency {
        RUB = 'RUB',
    }
}

